import Vue from 'vue'
import Router from 'vue-router'
import FillDetails from '../views/FillDetails'
import ReadInstructions from '../views/ReadInstructions'
import QuestionsPage from '../components/QuestionsPage'
import Feedback from '../components/Feedback'
import PracticeTest from '../components/PracticeTest'
import Home from '../views/Home'
import Error from '../components/Error'
import TestNotStarted from '../components/TestNotStarted'
import TestEnded from '../components/TestEnded'
import TestViolatePopup from '../components/TestViolatePopup'
import PrivacyPolicy from '../components/PrivacyPolicy'
import Faq from '@/views/Faq'
import Webcam from '../views/Webcam'
import Screenshot from '../views/Screenshot'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/fill-details',
      name: 'fill-details',
      component: FillDetails,
    },
    {
      path: '/fill-details/test/:test_id/user/:user_id',
      name: 'fill-details-dynamic',
      component: FillDetails,
    },
    {
      path: '/read-instructions/test/:test_id/user/:user_id',
      name: 'read-instructions',
      component: ReadInstructions,
    },
    {
      path: '/questions/test/:test_id/user/:user_id',
      name: 'questions',
      component: QuestionsPage,
    },
    {
      path: '/',
      redirect: { name: 'home' },
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback,
    },
    {
      path: '/practice-test',
      name: 'practice-test',
      component: PracticeTest,
    },
    {
      path: '/error/:type',
      name: 'error',
      component: Error,
    },
    {
      path: '/test-not-started',
      name: 'test-not-started',
      component: TestNotStarted,
    },
    {
      path: '/test-rules-violated',
      name: 'test-rules-violated',
      component: TestViolatePopup
    },
    {
      path: '/test-ended',
      name: 'test-ended',
      component: TestEnded,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      // path: '/webcam',
      path: '/webcam/test/:test_id/user/:user_id',
      name: 'webcam',
      component: Webcam,
    },
    {
      // path: '/screenshot',
      path: '/authenticate/test/:test_id/user/:user_id',
      name: 'screenshot',
      component: Screenshot
    }
  ],
})
